import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { PATHS } from "../../../infrastructure/app-config";
import PostalAreaViewModel from "../../../viewmodels/PostalAreaViewModel";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

export default function ManagerNavigationTabs() {
  const classes = useStyles();
  const vmAreas = PostalAreaViewModel.getInstance();
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();
  const location  = useLocation();
  const navigate = useNavigate();

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    vmAreas.currentPostalArea = undefined;
    vmAreas.cleanFilter();
    setValue(newValue);
    switch (newValue) {
      case 0:
        navigate(PATHS.postalAreas);
        break;
      case 1:
        navigate(PATHS.timeFrames);
        break;
      default:
        break;
    }
  };

  React.useEffect(() => {
    if (location.pathname) {
      if (location.pathname === PATHS.postalAreas) setValue(0);
      else if (location.pathname === PATHS.timeFrames) setValue(1);
    }
  }, [location.pathname]);

  return (
    <Paper className={classes.root}>
      <Tabs value={value} onChange={handleChange} indicatorColor="primary" textColor="primary" centered>
        <Tab label={t("navigationTabs.plaza_manager.managePostalArea")} />
        <Tab label={t("navigationTabs.plaza_manager.timeframes")} />
      </Tabs>
    </Paper>
  );
}
